import React from "react";
import { Button, Font } from "pepsico-ds";
import "./HomePageCarousal.css";
import { Box, Typography } from "@mui/material";

const OverlayContent = React.memo(
  ({ data }) => {
    const handleNavigation = (link) => {
      window.open(link, "_blank");
    };

    return (
      <div className="flex flex-col gap-2">
        <div className="relative text-white rounded w-full md-h-[210px] flex flex-col gap-2 items-start justify-between overflow-hidden">
          {/* Headline */}
          <Typography
            sx={{
              color: "var(--PepsiCo-White, #FFF)",
              fontFamily: "Inter, sans-serif",
              fontSize: "32px",
              fontWeight: 700,
              lineHeight: "44px",
              textAlign: "left",
            }}
          >
            {data?.headline}
          </Typography>

          {/* Description Box */}
          <Box
            sx={{
              color: "var(--PepsiCo-White, #FFF)",
              fontFamily: "Inter, sans-serif",
              fontSize: "18px",
              lineHeight: "28px",
              textAlign: "left",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 5, // ✅ limit to 4 lines
              textOverflow: "ellipsis",

              overflowY: "hidden",

              "& ol": {
                listStyleType: "decimal",
                paddingLeft: "1.5rem",
              },
              "& ul": {
                listStyleType: "disc",
                paddingLeft: "1.5rem",
              },
            }}
            dangerouslySetInnerHTML={{
              __html: data?.description || "",
            }}
          />

          {/* Button pinned to bottom */}
        </div>
        <Box sx={{ marginBottom: 1 }}>
          <Button
            style={{ background: "white" }}
            className="px-12"
            size="large"
            text={`${data.buttonText}`}
            variant="secondary"
            iconTrailing="arrow_right_alt"
            onClick={() => handleNavigation(data?.descriptionLink)}
          />
        </Box>
      </div>
    );
  },
  (prevProps, nextProps) => {
    // Only re-render if the data prop changes
    return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  }
);

export default OverlayContent;
